



















































































import Vue from 'vue';

export default Vue.extend({
  'name': 'AdminVehicleSearch',
  data () {
    return {
      'q': '',
      'lastQuery': '',
      'searched': false,
      'loading': false,
      'error': null as string | null,
      'results': [] as any[],
      'searchField': 'all' as 'all' | 'plate' | 'chassis' | 'make' | 'model'
    };
  },
  'computed': {
    isDealer (): boolean {
      return (this as any).$store.getters.isDealer;
    },
    searchFieldPlaceholder (): string {
      switch (this.searchField) {
        case 'plate': return 'e.g. WXM 2696 or WXM2696';
        case 'chassis': return 'e.g. MXUA80-0043611';
        case 'make': return 'e.g. TOYOTA';
        case 'model': return 'e.g. VIOS';
        default: return 'e.g. WXM, ABC1234, VIOS, TOYOTA';
      }
    }
  },
  'methods': {
    run () {
      const query = this.q.trim();
      if (!query) return;
      this.loading = true;
      this.error = null;
      this.lastQuery = query;
      const params: Record<string, string> = { 'q': query };
      if (this.searchField !== 'all') params.field = this.searchField;
      this.axios.get('admin/vehicle-search', { 'params': params })
        .then((res: any) => {
          this.results = res.data.result || [];
          this.searched = true;
        })
        .catch((e: any) => { this.error = e?.response?.data?.message || 'Search failed.'; })
        .finally(() => { this.loading = false; });
    },
    viewCustomerRoute (hit: any) {
      // Jul 2026: dealers land on their own /dealer/customers view rather than
      // the admin one they don't have access to.
      const routeName = this.isDealer ? 'DealerCustomerList' : 'AdminCustomerList';
      return { 'name': routeName, 'query': { 'customerId': hit.customerId } };
    },
    formatDate (s: string): string {
      if (!s) return '—';
      const d = new Date(s);
      const pad = (n: number) => String(n).padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    }
  }
});
